import 'shiki/themes/github-dark.mjs'; // or another theme you want to use
import $ from 'jquery';

async function initContentBlock() {
    const { createHighlighter } = await import('shiki')

    const highlighter = await createHighlighter({
        themes: ['github-dark'], // explicitly specify themes
        theme: 'github-dark',     // set the active theme
        langs: ['javascript', 'html', 'css', 'json', 'bash'],
    });

    $('.content-block pre').each(function () {
        const $code = $(this);
        const $parent = $code.parent();
        const codeText = $code.text();
        let lang = 'html';
        if ($parent.hasClass('language-js')) {
            lang = 'javascript';
        } else if ($parent.hasClass('language-css')) {
            lang = 'css';
        } else if ($parent.hasClass('language-json')) {
            lang = 'json';
        } else if ($parent.hasClass('language-bash')) {
            lang = 'bash';
        } else if ($parent.hasClass('language-html')) {
            lang = 'html';
        } else if ($parent.hasClass('language-text')) {
            lang = 'text';
        }

        const highlightedHTML = highlighter.codeToHtml(codeText, { lang  , theme: 'github-dark' });
        $code.replaceWith($(highlightedHTML));
    });
}

export { initContentBlock };
